import React from "react";
import { Play, Users, CheckCircle2, MessageCircle, Phone, MessageSquareText } from "lucide-react";

export const STAT_KEYS = [
  ["play", "Plays", Play], ["viewers", "Unique viewers", Users], ["complete", "Watched to end", CheckCircle2],
  ["chat", "Chat clicks", MessageCircle], ["call", "Call clicks", Phone], ["text", "Text clicks", MessageSquareText],
];
const RANGES = [[7, "Last 7 days"], [30, "Last 30 days"], [0, "All time"]];

export const RangeSwitch = ({ days, setDays }) => (
  <div className="inline-flex rounded-full border border-[#dcebe8] bg-white p-1" data-testid="video-stats-range">
    {RANGES.map(([d, l]) => (
      <button key={d} onClick={() => setDays(d)} className={`rounded-full px-3.5 py-1.5 text-[13px] font-semibold transition-colors ${days === d ? "bg-[#0f2e2a] text-white" : "text-[#4b5d5a] hover:bg-[#f2f7f6]"}`} data-testid={`video-stats-range-${d}`}>{l}</button>
    ))}
  </div>
);

export const TotalsBar = ({ totals }) => (
  <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-testid="video-stats-totals">
    {STAT_KEYS.map(([k, l, I]) => (
      <div key={k} className="rounded-2xl border border-[#e3f0ed] bg-white p-4">
        <div className="flex items-center gap-1.5 text-[12.5px] text-[#6b7c79]"><I size={14} className="text-[#0e8c7f]" />{l}</div>
        <div className="mt-1 font-jakarta text-[26px] font-extrabold text-[#0f2e2a]" data-testid={`video-total-${k}`}>{totals?.[k] ?? 0}</div>
      </div>
    ))}
  </div>
);

export const RowStats = ({ n, s }) => {
  const rate = s?.play ? Math.round((s.complete / s.play) * 100) : 0;
  return (
    <div className="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-[12px] text-[#4b5d5a]" data-testid={`video-stats-${n}`}>
      {STAT_KEYS.map(([k, l, I]) => (
        <span key={k} className="inline-flex items-center gap-1" title={l}><I size={12} className="text-[#0e8c7f]" /><b data-testid={`video-stat-${n}-${k}`}>{s?.[k] ?? 0}</b><span className="hidden sm:inline">{l.toLowerCase()}</span></span>
      ))}
      {s?.play > 0 && <span className="text-[#8a9a97]">· {rate}% finish</span>}
    </div>
  );
};
